// import '@babel/polyfill';
import 'mutationobserver-shim';
import Vue from 'vue';
import './plugins/bootstrap-vue';
import VueLazyload from 'vue-lazyload';
import VueCookies from 'vue-cookies';
import App from './App.vue';
import store from './store';

Vue.use(VueLazyload, { lazyComponent: true });
Vue.use(VueCookies);

Vue.$cookies.config(Infinity, '', '', false, 'Strict');

Vue.config.productionTip = false;

Vue.filter('formatSize', (size) => {
  // https://github.com/lian-yue/vue-upload-component/blob/master/docs/index.js#L112
  /* eslint-disable prefer-template */
  let formatted = null;
  if (size > 1024 * 1024 * 1024 * 1024) {
    formatted = (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + ' TB';
  } else if (size > 1024 * 1024 * 1024) {
    formatted = (size / 1024 / 1024 / 1024).toFixed(2) + ' GB';
  } else if (size > 1024 * 1024) {
    formatted = (size / 1024 / 1024).toFixed(2) + ' MB';
  } else if (size > 1024) {
    formatted = (size / 1024).toFixed(2) + ' KB';
  }
  return formatted || size.toString() + ' B';
  /* eslint-enable prefer-template */
});

new Vue({
  store,
  render: (h) => h(App),
}).$mount('#app');
